import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import useEditorStore from '../state-hook';
import ContributorControl from './contributor-control';
import CategoryControl from './categories-control';
import KeywordsControl from './keywords-control';
import StockCodesControl from './stock-codes-control';
import WireFeaturedContributorsControl from './wire-featured-contributors-control';
import CollectionsControl from './collections-control';
import SponsorshipControl from './sponsorship-control';
import CommercialControl from './commercial-control';
import ExclusiveContentControl from './exclusive-content-control';
import RestrictUserControl from './restricted-redirect-control';
import RestrictionsEventControl from './restricted-event-control';
import AttachmentsControl from './attachments-control';
import PrimaryImageControl from './primary-image-control';
import PermalinkControl from './permalink-control';
import AutoPublishWireControl from './auto-publish-wire-control';
import PublishWireControl from './publish-wire-control';
import FeatureWireControl from './feature-wire-control';

// eslint-disable-next-line complexity
export default function EditorSidebar({ showIsCommercial }) {
  const wire = useEditorStore(state => state.wire);
  const currentProfile = useEditorStore(React.useCallback(state => state.currentProfile, []));

  const { isEditor } = currentProfile;
  const id = _.get(wire, 'id');

  return (
    <>
      <div className="sidebar-group stack-top">
        {!!isEditor && <ContributorControl />}
        <WireFeaturedContributorsControl wireId={id} />
        <PrimaryImageControl wireId={id} mediaUrl={wire.primary_image_url} />
        <aside className="sidebar-item">
          <h2 className="header --no-border">
            <span>make your wire</span>
            &nbsp;discoverable
          </h2>
        </aside>
        <CategoryControl wireId={id} categoryId={_.get(wire, 'category.id')} />
        <KeywordsControl wireId={id} />
        <StockCodesControl wireId={id} stockCodes={_.get(wire, 'stockCodes', [])} />
      </div>
      <div className="sidebar-group stack-bottom">
        {!!isEditor && (
          <>
            <CollectionsControl wireId={id} />
            {!!showIsCommercial
              && <CommercialControl wireId={id} wasCommercial={wire.isCommercial} />}
            <SponsorshipControl wireId={id} wasSponsored={wire.isSponsored} />
          </>
        )}
        <ExclusiveContentControl wireId={id} originalUrl={wire.originalUrl} />
        {!!isEditor && (
          <>
            <RestrictUserControl
              wireId={id}
              wasRestrictedToRegisteredUsers={!!wire.isRestrictedToRegisteredUsers}
            />
            <RestrictionsEventControl
              wireId={id}
              restrictedToEventId={wire.restrictedToEventId || -1}
            />
          </>
        )}
        <AttachmentsControl wireId={id} />
        {!!_.get(currentProfile, 'canScheduleWire') && (
          <>
            <PermalinkControl
              wireId={id}
              wireTitleLength={_.get(wire, 'title.length', 0)}
              wireCategoryId={_.get(wire, 'category.id')}
              permalink={wire.permalink || ''}
              wirePublished={wire.published}
            />
            <AutoPublishWireControl
              wireId={id}
              autoPublishAt={wire.autoPublishAt}
              wirePublished={wire.published}
            />
            {!wire.firstPublishedAt && isEditor && <FeatureWireControl wireId={id} />}
          </>
        )}
        <PublishWireControl
          wireId={id}
          validations={['body', 'title', 'category', 'keywords', 'exclusiveness']}
          wireBodyEmpty={!wire.body}
          wireTitleLength={_.get(wire, 'title.length', 0)}
          wireCategoryId={_.get(wire, 'category.id')}
          autoPublishAt={wire.autoPublishAt}
          wirePublished={wire.published}
          approvalStatus={wire.approvalStatus}
          isFeatured={!!wire.featuredCount}
        />
      </div>
    </>
  );
}

EditorSidebar.propTypes = {
  showIsCommercial: PropTypes.bool.isRequired,
};
